<script lang="ts" setup>
import { OverviewTemplate } from '@/components/templates'
</script>

<template>
  <OverviewTemplate :getItemsFromRouter="true" />
</template>
